import { useMemo } from 'react'

const usePlainTextReplacer = () => {
	return useMemo(() => {
		if (!document) {
			return html => html
		}
		const element = document.createElement('div')

		return html => {
			element.innerHTML = _.replace(html || '', /<br\/?>/g, ' ')
			return html && element.innerText
		}
	}, [])
}

export default usePlainTextReplacer
